import { Component, EventEmitter, Input, Output, SimpleChanges, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import {DkDxDataCtlTableComponent} from "../../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent";
import {DxButtonModule, DxPopupModule} from "devextreme-angular";
import {ControlConditionModel} from "../../../models/gen-control.model";
import {Observable, Subject, takeUntil} from "rxjs";
import {ColumnModel} from "../../../models/dx-data-table.model";
import {DlistDto} from "../../../models/ortak.dtos";
import {OrtakService} from "../../../services/ortak.service";
import {CtlSearchPopupService} from "./ctl-search-popup.service";
// Dashboard Faz0 Clara: eski hâli — kullanılmayan IDE otomatik-importu (devexpress paketini boşuna çekiyordu)
// import {expression} from "devexpress-dashboard/model/data-item/metadata/_measure";

@Component({
  selector: 'dk-ctl-search-popup',
  standalone: true,
    imports: [CommonModule, DkDxDataCtlTableComponent, DxButtonModule, DxPopupModule],
  templateUrl: './ctl-search-popup.component.html',
  styleUrls: ['./ctl-search-popup.component.scss'],
})
export class CtlSearchPopupComponent {
  private destroyRef = inject(DestroyRef);
  @Input() popupVisible: boolean = false;
  @Input() isMultiSelect: boolean = false;
  @Input() controlName: any;
  @Input() controlEntity: any;
  @Input() donem: any;
  @Input() extends: string[];
  @Input() key: string;
  @Input() filterColumn = "";
  @Input() filterColumnValue: any;
  @Input() useOrCondition: boolean = false;
  @Input() controlCondition: ControlConditionModel[];
  @Output() public closePopUp: EventEmitter<any> = new EventEmitter();

  private destroy$ = new Subject<void>();
  public control!: any;
  public data: any;
  public selectedData: any = null;
  public columns: ColumnModel[];
  gridControlsList$: Observable<DlistDto>;
  public keyExpr: string

  public filterValue: any

  constructor(
    private service: CtlSearchPopupService,
    public ortakService: OrtakService
  ) {

    this.gridControlsList$ = this.service.gridControlsList$;
    this.service.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x => {
      this.columns = this.ortakService.setRecursiveFieldData([x], false);
    })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.getControl()
    if (this.filterColumnValue) {
      this.filterValue = [this.filterColumn, 'startswith', this.filterColumnValue]
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['controlName']){
      this.getControl()
    }

    if ( changes['donem']  || changes['controlCondition']) {
      this.data = this.service.getData(this.control, this.donem, this.controlCondition, this.useOrCondition, this.key,this.controlEntity, this.extends);

    }
  }

  focusChanged(e: any) {
    if(!this.isMultiSelect){
        this.selectedData = e.row;
      }
  }

  chooseBtnClick() {
    this.filterColumnValue = undefined;
    this.closePopUp.emit(this.selectedData);
  }

  cancelBtnClick() {
    this.filterColumnValue = undefined;
    this.closePopUp.emit(null);
  }

  getControl() {
    this.ortakService.getControl(this.controlName).pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.control = data?.controlMetadata;
        this.service._gridControlsList.next(data?.controlMetadata?.dlistMetadata)
        this.data = this.service.getData(this.control, this.donem, this.controlCondition, this.useOrCondition, this.key,this.controlEntity, this.extends);
      });
  }

  closePopupAfter($event: any) {
    this.closePopUp.emit(this.selectedData);
    this.popupVisible = false
  }

  selectedRowData($event: any) {
    if($event.selectedRowsData?.length >= 1 && this.isMultiSelect){
      this.selectedData= $event.selectedRowsData
    }
  }

  // Dashboard Faz0 Clara: eski hâli — ölü alan (şablonda kullanılmıyor), devexpress-dashboard importunu pakete çekiyordu
  // protected readonly expression = expression;
}
